module.exports = __webpack_public_path__ + "static/media/close-img.225b56cf.svg";